import { render, staticRenderFns } from "./UpdateDistributionLocation.vue?vue&type=template&id=75be6dd2"
import script from "./UpdateDistributionLocation.vue?vue&type=script&lang=js"
export * from "./UpdateDistributionLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports